import React from "react";
import { FaInstagram, FaFacebookF, FaYoutube } from "react-icons/fa";

export const SocialBar = () => {
  return (
    <div className="social-bar">
      <a
        href="https://www.instagram.com/janebayonne?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon instagram"
        aria-label="Instagram"
      >
        <FaInstagram color="#ffffff" />
      </a>

      <a
        href="https://www.facebook.com/people/Jane-Kuehn-Tucker-Bayonne/pfbid02GAQVTXL5u4CTjdLSmuKFSD1YGcqDG8DNFNgiJA16EunY6qrdJ5uTVGkozUQJUj1Wl/"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon facebook"
        aria-label="Facebook"
      >
        <FaFacebookF color="#ffffff" />
      </a>

      <a
        href="https://www.youtube.com/@jane-kuehn-tucker-bayonne"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon youtube"
        aria-label="YouTube"
      >
        <FaYoutube color="#ffffff" />
      </a>
    </div>
  );
};
